



import React, { useEffect } from 'react';
import Slider from 'react-slick';
import AOS from 'aos';
import 'aos/dist/aos.css'; // Import AOS styles
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

function Challenge() {
  useEffect(() => {
    AOS.init({
      duration: 1000, // Animation duration in ms
      once: true, // Animation should happen only once
    });
  }, []);

  const settings = {
    dots: true,
    infinite: false, // Disable looping
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: true,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  const containerStyle = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '400px', // Adjust the height as needed
    backgroundColor: '#f5f5f5',
  };

  const imageStyle = {
    maxWidth: '100%',
    maxHeight: '500px',
    objectFit: 'contain',
    padding: '10px', // Add padding for better spacing
  };

  return (
    <section className="tc-challenge-style2">
     

      {/* Image Slider Section */}
      <div className="content float_box_container">
        <Slider {...settings}>
         

          <div style={containerStyle}>
            <a href="/innerpages/assets/img/s_project2/final/05.jpg" data-fancybox="cases">
              <img
                src="/innerpages/assets/img/s_project2/final/05.jpg"
                alt="Project Management"
                style={imageStyle}
              />
            </a>
          </div>

          <div style={containerStyle}>
            <a href="/innerpages/assets/img/s_project2/final/06.jpg" data-fancybox="cases">
              <img
                src="/innerpages/assets/img/s_project2/final/06.jpg"
                alt="Project Management"
                style={imageStyle}
              />
            </a>
          </div>
        </Slider>
      </div>
    </section>
  );
}

export default Challenge;

